import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  turbine: {
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: '12px',
    padding: '2px 5px',
    marginTop: '10px',
  },
  valueTurbine: {
    textAlign: 'center',
    fontWeight: 'normal',
    color: 'black',
    padding: '0 2px',
  },
  spanLabel: {
    fontWeight: 'bold',
    padding: '0 2px',
    color: 'black',
  },
  divMain: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '5px',
    height: '40px',
    width: '100%',
    margin: 0,
    display: 'inline-flex',
    padding: 0,
    position: 'relative',
    minWidth: 0,
    flexDirection: 'column',
    verticalAlign: 'top',
  },
  label: {
    backgroundColor: 'white',
    zIndex: 1,
    pointerEvents: 'none',
    transition:
      'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    top: 0,
    left: 0,
    position: 'absolute',
    display: 'block',
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    lineHeight: '1',
    letterSpacing: '0.00938em',
  },
});
export default useStyles;
